// Head over to the Credentials section in your app on CometChat Dashboard and where you can find your unqiue App ID, Region and Auth Key. 😊

export const CometChatConstants = {
  appId: "249914e66d9b0378",
  region: "us",
  authKey: "275050136d1ec7f1ed31d05610820238994380c9",
};
